/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCompressAll = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 20h16v-2h2v4H2v-4h2zm0-6h16v-2h2v4H2v-4h2z" />
        <path d="m13 8.586 3.293-3.293 1.414 1.414L12 12.414 6.293 6.707l1.414-1.414L11 8.586V2h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgCompressAll as CompressAll };
